import { Field } from "../common/generic-form/fields/field";
import { FieldPassword } from "../common/generic-form/fields/field-password";
import { FieldTextBox } from "../common/generic-form/fields/field-textbox";

export const SYS_FIELDS_LOGIN: Map<string, Field> =
    new Map<string, Field>()
        .set('email', new Field(
            FieldTextBox,
            {
                key: 'email',
                label: 'Usuário',
                required: true,
                fieldName: 'email',
                tip: 'Digite seu usuário',
                autocomplete: 'username',
                icon: 'pi pi-user',
                labelClass: 'font-semibold text-900',
                type: 'email',
                inputMode: 'email',
                autoCapitalize: 'off',
                autoCorrect: 'off'
            }
        ))

        .set('password', new Field(
            FieldPassword,
            {
                key: 'password',
                label: 'Senha',
                required: true,
                fieldName: 'senha',
                tip: 'Digite sua senha',
                autocomplete: 'current-password',
                icon: 'pi pi-lock',
                labelClass: 'font-semibold text-900'
            }
        ))

export const SYS_FIELDS_RECOVER_PASSWORD: Map<string, Field> =
    new Map<string, Field>()
        .set('E_MAIL', new Field(
            FieldTextBox,
            {
                key: 'E_MAIL',
                label: 'E-Mail',
                required: true,
                fieldName: 'e-mail',
                tip: 'Digite seu e-mail',
                autocomplete: 'email',
                icon: 'pi pi-envelope',
                labelClass: 'font-semibold text-900',
                type: 'email',
                inputMode: 'email',
                autoCapitalize: 'off',
                autoCorrect: 'off'
            }
        ))

export const SYS_FIELDS_RESET_PASSWORD: Map<string, Field> =
    new Map<string, Field>()
        .set('password', new Field(
            FieldPassword,
            {
                key: 'password',
                label: 'Nova Senha',
                required: true,
                fieldName: 'password',
                tip: 'Digite sua nova senha'
            }
        ))
        .set('confirm_password', new Field(
            FieldPassword,
            {
                key: 'confirm_password',
                label: 'Confirmar Senha',
                required: true,
                fieldName: 'confirm_password',
                tip: 'Confirme sua nova senha'
            }
        ))
